// SPDX-FileCopyrightText: Copyright 2025 OP Financial Group (https://op.fi). All Rights Reserved.
//
// SPDX-License-Identifier: LicenseRef-OpAllRightsReserved

import React, { useState } from 'react';
import { Action } from '@op/opds.opux';
import message from '../messages';
import LeaveEServiceModalWindow from './LeaveEServiceModalWindow';

const LinkToMainPage: React.FC = () => {
    const [modalOpened, setModalOpened] = useState<boolean>(false);

    return (
        <>
            <LeaveEServiceModalWindow
                modalOpened={modalOpened}
                setModalOpened={setModalOpened}
                modalWindowText={message('returnToOpWarningText')}
            />
            <div className="opux-align-center opux-spacing-bottom-margin opux-spacing-top-margin-double">
                <Action onClick={() => setModalOpened(true)} data-testid="linkToMainPage">
                    {message('linkToMainPage')}
                </Action>
            </div>
        </>
    );
};

export default LinkToMainPage;
